import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import { wbp, reduceResolution } from 'Theme';

export const useCommonStyles = makeStyles((theme: Theme) =>
    createStyles({
        rowContainer: {
            [theme.breakpoints.down(wbp)]: {
                paddingLeft: `${reduceResolution(61)}px`
            },
            [theme.breakpoints.up(wbp)]: {
                paddingLeft: '30px'
            }
        },
        cellCenter: {
            display: 'flex',
            justifyContent: 'center'
        },
        cellRight: {
            display: 'flex',
            justifyContent: 'flex-end'
        },
        cellLeft: {
            display: 'flex',
            justifyContent: 'flex-start'
        },
        cellVerticalCenter: {
            display: 'flex',
            alignItems: 'center'
        },
        capitalize: {
            textTransform: 'capitalize'
        },
        desktop: {
            [theme.breakpoints.down('sm')]: {
                display: 'none'
            }
        },
        mobile: {
            [theme.breakpoints.up('md')]: {
                display: 'none'
            }
        },
        typeCell: {
            maxWidth: '12%',
            flexBasis: '12%',
            [theme.breakpoints.down('md')]: {
                display: 'none'
            }
        },
        extraInfoWrapper: {
            display: 'block',
            [theme.breakpoints.up('md')]: {
                display: 'flex',
                fontWeight: '500 !important'
            },
            [theme.breakpoints.down('md')]: {
                fontSize: 16,
                fontWeight: '600 !important'
            }
        },
        extraInfo: {
            display: 'block',
            width: '100%',
            fontSize: 14,
            fontWeight: 400,
            [theme.breakpoints.up('md')]: {
                display: 'none'
            }
        },
        smallWidthCell: {
            maxWidth: '9%',
            flexBasis: '9%',
            [theme.breakpoints.down('md')]: {
                display: 'none'
            }
        },
        smallWidthCellDetail: {
            maxWidth: '9%',
            flexBasis: '9%',
            [theme.breakpoints.down('md')]: {
                display: 'none'
            }
        },
        bigWidthCell: {
            maxWidth: '63.2%',
            flexBasis: '63.2%',
            [theme.breakpoints.down('md')]: {
                display: 'none'
            }
        },
        actions: {
            [theme.breakpoints.down('md')]: {
                display: 'flex',
                justifyContent: 'flex-end',
                maxWidth: '16.6%',
                flexBasis: '16.6%',
                paddingRight: '0px !important'
            }
        }
    })
);
